import { render, staticRenderFns } from "./rental.vue?vue&type=template&id=96d18a5c&scoped=true&"
import script from "./rental.vue?vue&type=script&lang=js&"
export * from "./rental.vue?vue&type=script&lang=js&"
import style0 from "./rental.vue?vue&type=style&index=0&id=96d18a5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d18a5c",
  null
  
)

export default component.exports